import React, { useState, useEffect, useContext } from "react";
import { Redirect } from "react-router-dom";
import { Link } from "react-router-dom";
import Home from "../Home/Home";
import { api } from "../../utils/Api";
import DeleteAlert from "../../components/Alert/DeleteAlert";
export default function Profile(props: any) {
  const [profileDetails, setProfileDetails] = useState("");
  const [formData, setFormData] = useState({});

  const [delete_modal, SetDeleteModal] = useState({
    is_open: false,
    title: "",
    record: {},
    index: "",
  });

  async function get_submitSellForm() {
    console.log("formData :", formData);
    let pass_data = {
      post: formData,
    };

    const response = await api("/users/edit_profile_details", pass_data);
    console.log("get_subCategory response :", response);

    if (response.status_code == 200) {
      // let old_services = service_data;
      // old_services.splice(index, 1);
      // SetServiceData([...old_services]);
      get_profile();
    }

    // let selected_img = this.state.selected_files.data;
    // console.log("get_selected_files :", selected_img);

    // for (var i = 0; i < selected_img.length; i++) {
    //   console.log("selected_img.item(i) :", selected_img[i].file);
    //   var img = selected_img[i].file;
    //   const response = await Api.upload_image(img);
    //   console.log("upload_image response :", response);
    // }

    // console.log(this.state);
  }

  function input_on_changes(event: any) {
    console.log("input_on_change value", event.target.value);
    console.log("input_on_change value", event.target.name);

    let key_name = event.target.name;
    let key_value = event.target.value;

    setFormData((prevState) => {
      // ...prevState,
      prevState[key_name] = key_value;
      return { ...prevState };
    });

    // setFormData(
    //   (prevState) => ({
    //     ...prevState,
    //     formData: {
    //       ...prevState.formData,
    //       [key_name]: key_value,
    //     },
    //   }),
    //   () => {
    //     formData;
    //   }
    // );

    console.log(formData);
  }

  async function get_profile() {
    //     // }
    let response = await api("/users/profile");
    console.log("app_init :", response);

    setProfileDetails(response.response);

    console.log(profileDetails);
  }

  async function delete_service(record: any, index: any) {
    let pass_data = {
      post: {
        experience_id: record,
      },
    };
    let data = await api("/users/delete_experience", pass_data);
    console.log("delete_service response :", data);
    if (data.status_code == 200) {
      // let old_services = service_data;
      // old_services.splice(index, 1);
      // SetServiceData([...old_services]);
      get_profile();
    }
  }

  async function disable() {
    let pass_data = {
      post: "",
    };

    const response = await api("/users/disable_account", pass_data);
    console.log("enable response :", response);

    if (response.status_code == 200) {
      window.location.href = "/";
    }
  }

  async function delete_profile() {
    let pass_data = {
      post: "",
    };

    const response = await api("/users/delete_account", pass_data);
    console.log("enable response :", response);

    if (response.status_code == 200) {
      window.location.href = "/";
    }
  }

  useEffect(() => {
    console.log("Profile On mount :", props);

    get_profile();
    console.log(profileDetails);
  }, []);

  return (
    <>
      <div className="container">
        <div className="row pt-3">
          <div className="card col-lg-8">
            <div className="card-body">
              {/* <h5 className="card-title">Card title</h5>
                <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                        <a href="#" className="btn btn-primary">Go somewhere</a> */}

              
                <div className="row">
                  <div className=" col-lg-4">
                    {/* only if conditon */}
                    {profileDetails != "" && (
                      <>
                        <img
                                  src={profileDetails.user_details.dp_url}
                          className="img-fluid"
                        />
                      </>
                    )}
                    

                    
                    {profileDetails != "" && ( 
                    <div className="py-3 fw-bolder fs-5 text-center">
                      
                    
                      &#x20B9;{  profileDetails.basic_details.hourly_price } INR/hr</div>
                      )}
                    
                    {/* <div className="py-3 fw-bolder fs-5 text-center">
                          <b>
                            &#x20B9;{profileDetails.basic_details.hourly_price}
                            INR/hr
                          </b>
                        </div> */}
                  </div>
                  
                  <div className="card col-lg-7">
                    {profileDetails != "" ? (
                      <>
                        <div className="d-lg-flex">
                          <h3> {profileDetails.user_details.name}</h3>

                          <p className="ps-lg-3 fs-5 text-sm-center text-muted fw-bold">
                            @{profileDetails.user_details.username}
                          </p>
                        </div>

                        <div className="fw-light fs-4 pb-6">
                          {profileDetails.basic_details.title}
                        </div>
                        <div className="card col-lg-7">
                          {profileDetails != "" && (
                            <div className="pt-3">
                              <div className="fs-6">
                                {profileDetails.basic_details.description}
                              </div>
                            </div>
                          )}
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="col-lg-1">
                    <button
                      type="button"
                      className="btn btn-primary btn-sm px-3"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModaledit"
                    >
                      Edit
                    </button>

                    <div
                      className="modal fade"
                      id="exampleModaledit"
                      tabindex="-1"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                              Edit profile
                            </h5>
                            <button
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>
                          <div className="modal-body">
                            <p>title </p>
                            <input
                              className="form-control"
                              onChange={(event) => {
                                input_on_changes(event);
                              }}
                              name="title"
                              type="text"
                              placeholder=""
                            />
                            <br></br>

                            <p>Description</p>
                            <div className="description">
                              <textarea
                                onChange={(event) => {
                                  input_on_changes(event);
                                }}
                                name="description"
                                className="form-control"
                                id="exampleFormControlTextarea1"
                                rows="3"
                              ></textarea>
                            </div>

                            <br></br>

                            <p>price </p>
                            <input
                              className="form-control"
                              onChange={(event) => {
                                input_on_changes(event);
                              }}
                              name="hourly_price"
                              type="text"
                              placeholder=""
                            />
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              data-bs-dismiss="modal"
                            >
                              Close
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                console.log("hgfd", formData);
                                get_submitSellForm();
                              }}
                              className="btn btn-primary"
                              data-bs-dismiss="modal"
                            >
                              Save changes
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              

              
                
              
            </div>
          </div>
          &nbsp; &nbsp;

          <div className="card p-3 col-lg-3 ">
            <div className="d-flex align-items-center">
              <h5 className="mb-0">Top Skills</h5>

              <div className="ms-auto">

              <Link
                to="/skills"
                data-bs-toggle="tooltip"
                data-bs-placement="bottom"
                className="btn btn-primary btn-sm px-3"
              >
                  Edit 
                
              </Link>
              </div>
            </div>
            <hr/>

            {profileDetails != "" ? (
              <div>
                {profileDetails.user_skills.map((item, i) => (
                  <ul className="fs-6">{item.name}</ul>
                ))}
              </div>
            ) : (
              "null"
            )}
          </div>
        </div>
      </div>
      <br></br>
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <div className="card mb-4">
              <div className="card-body">
                <div className="d-flex">
                  <h5 className="ps-4 pt-4 col-11">Experience</h5>

                  <Link
                    to="/add_experience"
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                    title="Company Join Invitation"
                    className="d-lg-block d-sm-none d-md-none"
                  >
                    <button
                      type="button"
                      className="btn btn-primary btn-sm px-3  mt-3 "
                    >
                      Add
                    </button>
                  </Link>
                </div>
                <hr />

                {profileDetails != "" ? (
                  <div>
                    {profileDetails.experience_details.map((item, i) => (
                      <>
                        <div className="container">
                          <div className="row">
                            <div className="col">
                              <div className="fs-16">{item.company}</div>
                              <div className="fs-6 mb-2">{item.designation}</div>
                              <div className="text-muted fw-bold">
                                {item.from}
                                {item.present ? "" : " - " + item.to}
                              </div>
                            </div>
                            <div className="col">
                              {/* <!-- Button trigger modal --> */}
                              <div
                                role="button"
                                data-bs-toggle="modal"
                                data-bs-target="#exampleModal"
                                onClick={() => {
                                  // delete_service(data, s_index);
                                  SetDeleteModal((prevValue) => {
                                    prevValue.is_open = true;
                                    prevValue.title = "experience";
                                    prevValue.record = item.id;
                                    prevValue.index = i;
                                    return { ...prevValue };
                                  });
                                }}
                              >
                                <div className="fw-bold text-danger text-end">
                                  <i className="fa-solid fa-trash-can"></i>{" "}
                                  Remove
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <hr/>
                      </>
                    ))}
                  </div>
                ) : (
                  "null"
                )}
              </div>
            </div>

            <button
              type="button"
              className="col-2 btn btn-warning btn-sm me-2"
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
            >
              Disable Account
            </button>

            <div
              className="modal fade"
              id="exampleModal"
              tabindex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">
                      Disable Account
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    Do you want to disable the account?
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      No
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        disable();
                      }}
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <button
              type="button"
              className="col-2 btn btn-danger btn-sm"
              data-bs-toggle="modal"
              data-bs-target="#exampleModal1"
            >
              Delete Account
            </button>

            <div
              className="modal fade"
              id="exampleModal1"
              tabindex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">
                      Delete Account
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    Do you want to delete the account?
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      No
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        delete_profile();
                      }}
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DeleteAlert
        open={delete_modal.is_open}
        title={delete_modal.title}
        record={delete_modal.record}
        index={delete_modal.index}
        close={(data) => {
          SetDeleteModal((prevValue) => {
            prevValue.is_open = false;
            return { ...prevValue };
          });

          if (data.action === "delete") {
            console.log("delete Service : ", data);
            delete_service(data.value, data.index);
          }
        }}
      />
    </>
  );
}
